import { render, staticRenderFns } from "./SocialPlayer.vue?vue&type=template&id=cfe8cca0&"
import script from "./SocialPlayer.vue?vue&type=script&lang=js&"
export * from "./SocialPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SocialPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfe8cca0')) {
      api.createRecord('cfe8cca0', component.options)
    } else {
      api.reload('cfe8cca0', component.options)
    }
    module.hot.accept("./SocialPlayer.vue?vue&type=template&id=cfe8cca0&", function () {
      api.rerender('cfe8cca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Player/SocialPlayer.vue"
export default component.exports